var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m223.7 130.8-74.6-123.03c-2-4.821-7.2-7.77-12.8-7.77h-120.27c-12.95 0-20.53 14.58-13.1 25.18l111.3 158.9c29.67-27.68 67.47-46.78 109.47-53.28zm32.3 29.2c-97.25 0-176 78.75-176 176s78.8 176 176 176 176-78.75 176-176-78.7-176-176-176zm92.5 157.3-37.88 37 8.875 52.25c1.625 9.25-8.25 16.5-16.63 12l-46.88-24.62-46.885 24.57c-8.375 4.5-18.25-2.75-16.63-12l8.875-52.25-37.88-37c-6.865-6.65-2.965-18.25 6.435-19.65l52.38-7.625 23.42-47.475c2-4.25 6.125-6.375 10.25-6.375s8.25 2.175 10.25 6.375l23.5 47.5 52.38 7.625c9.52 1.375 13.32 12.975 6.42 19.675zm146.6-317.3h-119.4c-5.621 0-10.83 2.949-13.72 7.77l-73.76 122.1c42 6.5 79.88 25.62 109.5 53.38l111.3-158.9c7.48-9.77-.12-24.35-13.92-24.35z",
    fill: "#c4c4c4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalSolid);
export default __webpack_public_path__ + "static/media/medal-solid.e8987268db7d2f74b50cd7b0e540e04b.svg";
export { ForwardRef as ReactComponent };